module.exports = __webpack_public_path__ + "static/media/BackgroundCircle.9956e2b5.svg";